import {formatPercentage, getProfitStatusColor} from '../../utils'
import {WeeklyBreakdownTableRowProps} from '../../types'
import { formatPrice } from '../../../../utils/common'

const WeeklyBreakdownTableRow = ({row, index}: WeeklyBreakdownTableRowProps) => {
  return (
    <tr>
      <td>{row?.week || '-'}</td> 
      <td>
        {row.date || '-'}
      </td>
      <td>
        {row.profit_percentage ? (
          <span className={`badge ${getProfitStatusColor(row.profit_percentage)}`}>
            {formatPercentage(row.profit_percentage)}
          </span>
        ) : (
          '-'
        )}
      </td>
      <td>{row.orders || '-'}</td>
      <td className='text-end'>{row.revenue ? formatPrice(row.revenue.toString(), false) : '-'}</td>
    </tr>
  )
}

export default WeeklyBreakdownTableRow
